import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

/**
 * Save email notification consent (opt-in / opt-out) for the authenticated user.
 */
export const updateEmailConsent = async (
  accessAuthToken: string,
  optIn: boolean,
  source: string = "terms_and_conditions"
): Promise<{ emailNotificationsOptIn: boolean }> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/users/email-consent`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ optIn, source }),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to update email consent");
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating email consent:", error);
    showErrorToast("Failed to save email notification preferences");
    throw error;
  }
};

/**
 * Get current email notification consent status for the authenticated user.
 */
export const getEmailConsent = async (
  accessAuthToken: string
): Promise<{ emailNotificationsOptIn: boolean | null }> => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/users/email-consent`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessAuthToken}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to get email consent status");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching email consent:", error);
    throw error;
  }
};
